import React, { useState } from 'react';
import { FiPackage, FiBox } from 'react-icons/fi';
import { theme } from '../theme';

interface Tab {
  id: string;
  label: string;
  icon: React.ReactNode;
  component: React.ReactNode;
}

interface InsumosTabsProps {
  insumosComponent: React.ReactNode;
  objetosComponent: React.ReactNode;
}

export const InsumosTabs: React.FC<InsumosTabsProps> = ({
  insumosComponent,
  objetosComponent
}) => {
  const [activeTab, setActiveTab] = useState('insumos');

  const tabs: Tab[] = [
    {
      id: 'insumos',
      label: 'Insumos',
      icon: React.createElement(FiPackage as any),
      component: insumosComponent
    },
    {
      id: 'objetos',
      label: 'Objetos',
      icon: React.createElement(FiBox as any),
      component: objetosComponent
    }
  ];

  return (
    <div style={{ width: '100%' }}>
      {/* Pestañas */}
      <div style={{ 
        borderBottom: `1px solid ${theme.colors.borderLight}`,
        marginBottom: '24px'
      }}>
        <nav style={{ 
          display: 'flex',
          gap: '32px',
          marginBottom: '-1px'
        }}>
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              style={{
                padding: '12px 4px',
                borderBottom: `2px solid ${activeTab === tab.id ? theme.colors.secondary : 'transparent'}`,
                color: activeTab === tab.id ? theme.colors.secondary : theme.colors.textSecondary,
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: theme.fontSizes.normal,
                fontWeight: 500,
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                transition: 'all 0.3s ease',
                whiteSpace: 'nowrap'
              }}
              onMouseEnter={(e) => {
                if (activeTab !== tab.id) {
                  e.currentTarget.style.color = theme.colors.textPrimary;
                }
              }}
              onMouseLeave={(e) => {
                if (activeTab !== tab.id) {
                  e.currentTarget.style.color = theme.colors.textSecondary;
                }
              }}
            >
              {tab.icon}
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Contenido de las pestañas */}
      <div>
        {tabs.find(tab => tab.id === activeTab)?.component}
      </div>
    </div>
  );
};

